export enum MessageAction {
  MarkUnread = 1,
  MarkRead,
  Close,
  OptOut
}

export enum ContactGroupAction {
  RenameGroup = 1,
  CopyGroup,
  DeleteGroup,
}

export const MESSAGE_ACTIONS = [
  {
    id: MessageAction.MarkUnread,
    name: 'Mark as Unread'
  },
  {
    id: MessageAction.MarkRead,
    name: 'Mark as Read'
  },
  {
    id: MessageAction.Close,
    name: 'Close Message'
  },
  {
    id: MessageAction.OptOut,
    name: 'Opt Out'
  }
];

export const CONTACT_GROUP_ACTIONS = [
  {
    id: ContactGroupAction.RenameGroup,
    name: 'Rename Group'
  },
  {
    id: ContactGroupAction.CopyGroup,
    name: 'Copy Group'
  },
  {
    id: ContactGroupAction.DeleteGroup,
    name: 'Delete Group'
  }
];

export interface ActionPayload {
  messageIds: string[];
}

export interface ContactGroupActionPayload {
  groupId: number;
}

export interface ReadActionPayload extends ActionPayload {
  isRead: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/communications/cards/actions/Actions.ts